<template>
    <div class="el-stencil-item" :style="{width: uiWidth, height: uiHeight}"></div>
</template>
<script>
export default {
    name: 'mead-loading-stencil',
    props: {
        /**
         * Height of the stencil (any valid CSS size value). Defaults to 100% if not provided.
         */
        uiHeight: {type: String, default: '100%'},
        /**
         * Width of the stencil (any valid CSS size value). Defaults to 100% if not provided.
         */
        uiWidth: {type: String, default: '100%'}
    }
}
</script>
<style lang="scss">
@import '../../../../sass/_variables.scss';

.el-stencil-item {
    position: relative;
    overflow: hidden;

    //  Fix for a safari bug where overflow hidden somehow doesn't apply to pseudo elements
    @media screen and (max-width: $mq-ds) {
        -webkit-mask-image: -webkit-radial-gradient(white, black);
    }

    &:after {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        content: '';
        animation: stencil 1.5s linear forwards infinite;
        background: linear-gradient(90deg, var(--c-stencil-bg), var(--c-stencil-bg-load), var(--c-stencil-bg));
        transform: translateX(-100%);
    }
}
</style>